<template>
  <div id="Big_data">
    <div class="font">
      <span class="introSubTitle"><b>时空大数据平台</b></span>
      <p class="textStyle">研制了时空大数据平台，基于统一的时空框架，集成融合各种基础地理空间数据、专题空间数据、空天地传感网动态数据、移动人群及其便携设备、线上社交媒体数据以及各种社会经济数据，实现了时空信息的汇聚、融合、处理、管理、服务与应用，为时空大数据在智慧城市、智慧社会、应急管理的应用等提供了解决方案。</p>
    </div>
    <div style="text-align: center">
      <img width="80%" src="@/assets/img/scientific/Big_data.jpg" />
      <p class="img_figure">平台架构</p>
      <img width="80%" src="@/assets/img/scientific/BigData2.png" />
      <p class="img_figure">构建一张时空全息图</p>
      <img width="80%" src="@/assets/img/scientific/smartCity1.png" />
      <p class="img_figure">全要素高精度一张图</p>
    </div>

  </div>
</template>

<script>

export default {
  data() {
    return {

    };
  },
};
</script>

<style lang="less">
#Big_data {
  margin-top: 20px;
  .img_figure{
    display: flex;
    justify-content: center;
    font-size: 14px;
    color: #454545;
  }
  // .font {
  //   // font-family: "Times New Roman", Times, serif;
  // }
}
</style>
